import { PAGEPATHS } from "../../components/Common/Constant"
import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import { useParams } from "react-router-dom" //
import { ApiNames } from '../../components/Common/ApiManagement/apiServices'
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { TableHeader } from "components/Common/common";
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import DataTableWithPopup from "components/longContentTable";

const UsWebDesignStd = (props) => {
    document.title = "US Web Design Standards";
    // const [scanId, setScanId] = useState(sessionStorage.getItem('scanId'))
    const { scanId: paramScanId } = useParams();
    const [scanId, setScanId] = useState(paramScanId || sessionStorage.getItem('scanId'));
    const [uswds2Data, setUswds2Data] = useState({})

    const breadcrumbItems = [
        { title: "Scan List", link: PAGEPATHS.Scanlist },
        { title: sessionStorage.getItem('domain'), link: "#" },
        { title: "US Web Design Standards", link: "#" }
    ]

    useEffect(() => {
        props.setBreadcrumbItems("US Web Design Standards", breadcrumbItems)
    })

    useEffect(() => {
        const getUsWebDesignStdData = async () => {
            try {
                const { data } = await axiosInstance.get(`${ApiNames.FETCH_USWDS2_SCAN}/${scanId}`)
                const valid = Object.entries(data.data).reduce((a, v) => {
                    a.columns.push({
                        label: v[0],
                        field: v[0],
                        sort: 'asc',
                        width: 150
                    })
                    if (typeof v[1] === 'boolean' || v[1] === 0) {
                        a.rows[0][v[0]] = v[1].toString()
                    } else if (v[1] === null) {
                        a.rows[0][v[0]] = 'NaN'
                    } else {
                        a.rows[0][v[0]] = v[1]
                    }
                    return a
                }, { columns: [], rows: [{}] })
                setUswds2Data(valid)
            } catch (e) {
                console.error(e);
            }
        }
        getUsWebDesignStdData()
    }, [scanId])

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <TableHeader scanName={"USWDS 2"} scanId={scanId} />
                        <CardBody className="search-engine-table">
                            {uswds2Data && uswds2Data.rows && (
                                <DataTableWithPopup noBottomColumns thirdPartyData={uswds2Data} />
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment >
    )
}
export default connect(null, { setBreadcrumbItems })(UsWebDesignStd)